const EditIcon: React.FC = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.36637 13.6458H3.55387L11.6997 5.5L10.5122 4.3125L2.36637 12.4583V13.6458ZM0.699707 15.3125V11.7708L11.6997 0.791667C11.8664 0.638889 12.0504 0.520833 12.2518 0.4375C12.4532 0.354167 12.665 0.3125 12.8872 0.3125C13.1094 0.3125 13.3247 0.354167 13.533 0.4375C13.7414 0.520833 13.9219 0.645833 14.0747 0.8125L15.2205 1.97917C15.3872 2.13194 15.5087 2.3125 15.5851 2.52083C15.6615 2.72917 15.6997 2.9375 15.6997 3.14583C15.6997 3.36806 15.6615 3.57986 15.5851 3.78125C15.5087 3.98264 15.3872 4.16667 15.2205 4.33333L4.24137 15.3125H0.699707ZM11.0955 4.91667L10.5122 4.3125L11.6997 5.5L11.0955 4.91667Z"
        fill="#6E6E6E"
      />
    </svg>
  );
};

export default EditIcon;
